import React from "react";
import Text from "../../contentBlocks/Text.react";
import Separator from "../../contentBlocks/Separator.react";
import ButtonGroup from "../../contentBlocks/ButtonGroup.react";
import SlideHeader from "../../contentBlocks/SlideHeader.react";
import PropTypes from "prop-types";
import SlideHeaderSidebar from "../../contentBlocks/SlideHeaderSidebar.react";
import { Grid } from "semantic-ui-react";

export default class KnowMoreSingleSelect extends React.Component {
    static propTypes = {
        data: PropTypes.shape({
            title: PropTypes.string,
            subtitle: PropTypes.string,
            iconlist: PropTypes.array,
            options: PropTypes.array,
            question: PropTypes.string,
        }).isRequired,
        colors: PropTypes.shape({
            baseText: PropTypes.string,
            primary: PropTypes.string,
        }).isRequired,
        slideId: PropTypes.number,
        mobileView: PropTypes.bool,
    };
    static defaultProps = {
        mobileView: false,
    };
    handleClick = (index) => {
        this.props.trackInteraction(index);
    };

    render() {
        let isPortrait =
            this.props.mobileView || window.innerHeight > window.innerWidth;
        let defaultStyle = {
            margin: "auto",
            width: "80%",
            textAlign: "center",
            paddingTop: window.innerWidth > 1400 ? "50px" : "25px",
        };
        let defaultLandscapeStyle = {
            margin: "15px auto",
            width: "100%",
            textAlign: "center",
            position: "relative",
            float: "right",
            padding: "30px",
        };
        let title =
            this.props.data.header !== undefined
                ? this.props.data.header
                : this.props.data.title;
        let subtitle =
            this.props.data.subheader !== undefined
                ? this.props.data.subheader
                : this.props.data.subtitle;
        return (
            <div className="full-height">
                {isPortrait && (
                    <SlideHeader
                        {...this.props}
                        title={title}
                        subtitle={subtitle}
                    />
                )}
                {isPortrait && (
                    <div style={defaultStyle}>
                        <Text
                            keyName={"question-" + this.props.slideId}
                            text={this.props.data.question}
                            color={this.props.colors.baseText}
                            fontSize="large"
                            animation="transition.expandIn,500,500"
                        />
                        <Separator
                            keyName="separator"
                            color={this.props.colors.primary}
                            animation="transition.bounceLeftIn,500,500"
                        />
                        <ButtonGroup
                            keyName="options"
                            colors={this.props.colors}
                            options={this.props.data.options}
                            extractFrom="text"
                            animation="transition.slideDownIn,500,500"
                            callback={this.handleClick}
                        />
                    </div>
                )}

                {!isPortrait && (
                    <Grid style={{ minHeight: "100%" }}>
                        <Grid.Row style={{ paddingBottom: "0" }}>
                            <Grid.Column
                                width={8}
                                style={{
                                    paddingRight: "0",
                                    background: this.props.colors.primary,
                                }}
                            >
                                <SlideHeaderSidebar
                                    {...this.props}
                                    title={title}
                                    subtitle={subtitle}
                                />
                            </Grid.Column>
                            <Grid.Column width={8} style={{ paddingLeft: "0" }}>
                                <div style={defaultLandscapeStyle}>
                                    <Text
                                        keyName={
                                            "question-" + this.props.slideId
                                        }
                                        text={this.props.data.question}
                                        color={this.props.colors.baseText}
                                        fontSize="large"
                                        animation="transition.expandIn,500,500"
                                    />
                                    <Separator
                                        keyName="separator"
                                        color={this.props.colors.primary}
                                        animation="transition.bounceLeftIn,500,500"
                                    />
                                    <ButtonGroup
                                        keyName="options"
                                        colors={this.props.colors}
                                        options={this.props.data.options}
                                        extractFrom="text"
                                        animation="transition.slideDownIn,500,500"
                                        callback={this.handleClick}
                                    />
                                </div>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                )}
            </div>
        );
    }
}
